import * as C from "../constants";
import { createReducer } from "../utils/misc";

const initialState = {
    isLoading: false,
    isLoaded: false,
    count: null,
    data: [],
    roles: [],
    rolesIsLoading: false,
    rolesIsLoaded: false,
    statusText: null,
    organizations: [],
    organizationsIsLoaded: false,
    organizationsIsLoading: false,
    notifications: [],
    notificationsIsLoaded: false,
    notificationsIsLoading: false,
    notificationsCount: null,
    notificationsNewCount: null,
};

export default createReducer(initialState,{
    [C.GET_USERS_REQUEST]: (state) => ({
        ...state,
        isLoading: true,
    }),
    [C.GET_USERS_FAILURE]: (state) => ({
        ...state,
        isLoaded: false,
        isLoading: false,
        statusText: "Ошибка загрузки данных пользователей."
    }),
    [C.GET_USERS_SUCCESS]: (state, payload) => ({
        ...state,
        isLoading: false,
        isLoaded: true,
        data: payload.users,
        count: payload.count,
        page: payload.page,
        pages: payload.pages,
    }),
    [C.CREATE_USER]: (state, payload) => ({
        ...state,
        data: [
            ...state.data,
            payload,
        ].sort((a, b) => (a.id > b.id ? 1 : -1)),
        count: state.count + 1,
    }),
    [C.CREATE_USER_FAILURE]: (state) => ({
        ...state,
        statusText: "Ошибка создания нового пользователя."
    }),
    [C.EDIT_USER]: (state, payload) => ({
        ...state,
        data: state.data.map(user => (user.id !== payload.id ? user : payload)),
    }),
    [C.EDIT_USER_FAILURE]: (state) => ({
        ...state,
        statusText: "Ошибка изменения пользователя."
    }),
    [C.DEL_USER]: (state, payload) => ({
        ...state,
        data: state.data.map(user => (user.id !== payload ? user : null)).filter(n => n),
        count: state.count - 1,
    }),
    [C.DEL_USER_FAILURE]: (state) => ({
        ...state,
        statusText: "Ошибка удаления пользователя."
    }),
    [C.GET_ROLES_REQUEST]: (state) => ({
        ...state,
        rolesIsLoading: true,
    }),
    [C.GET_ROLES_FAILURE]: (state) => ({
        ...state,
        rolesIsLoading: false,
        rolesIsLoaded: false,
        statusText: "Ошибка загрузки ролей"
    }),
    [C.GET_ROLES_SUCCESS]: (state, payload) => ({
        ...state,
        rolesIsLoadings: false,
        rolesIsLoaded: true,
        roles: payload,
    }),
    [C.GET_USERS_ORGANIZATIONS_REQUEST]: (state) => ({
        ...state,
        organizationsIsLoading: true,
    }),
    [C.GET_USERS_ORGANIZATIONS_FAILURE]: (state) => ({
        ...state,
        organizationsIsLoaded: false,
        organizationsIsLoading: false,
        statusText: "Ошибка загрузки списка организаций."
    }),
    [C.GET_USERS_ORGANIZATIONS_SUCCESS]: (state, payload) => ({
        ...state,
        organizations: payload,
        organizationsIsLoading: false,
        organizationsIsLoaded: true,
    }),
    [C.GET_NOTIFICATIONS_REQUEST]: (state) => ({
        ...state,
        notificationsIsLoading: true
    }),
    [C.GET_NOTIFICATIONS_FAILURE]: (state) => ({
        ...state,
        notificationsIsLoaded: false,
        notificationsIsLoading: false,
        statusText: "Ошибка загрузки оповещений",
    }),
    [C.GET_NOTIFICATIONS_SUCCESS]: (state, payload) => ({
        ...state,
        notificationsIsLoaded: true,
        notificationsIsLoading: false,
        notifications: payload.notifications,
        notificationsCount: payload.count,
        notificationsNewCount: payload.new_count,
    })
})


// WEBPACK FOOTER //
// ./src/reducers/users.js